import { render } from "./Wrapper.vue?vue&type=template&id=21d13154&scoped=true&ts=true"
import script from "./Wrapper.vue?vue&type=script&lang=ts"
export * from "./Wrapper.vue?vue&type=script&lang=ts"

import "./Wrapper.vue?vue&type=style&index=0&id=21d13154&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d13154"]])

export default __exports__